module.exports = __webpack_public_path__ + "img/1481805038.c0b13a6e.jpg";